import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    globalLoader: true,
}

const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        loading: (state) => {
            state.globalLoader = true
        },
        loaded: (state) => {
            state.globalLoader = false
        }
    },
    extraReducers: {
        ['fetchHome/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchAbout/fulfilled']: (state, action) => {
            state.globalLoader = false
        },

        ['fetchBusiness/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchCareer/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchContact/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchEsg/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchMedia/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchMediaDetail/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchPosts/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchBanner/fulfilled']: (state, action) => {
            state.globalLoader = false
        },

        ['fetchPostDetail/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchDataDetail/fulfilled']: (state, action) => {
            state.globalLoader = false
        },


    }
})


export default globalSlice.reducer
export const {loaded, loading} = globalSlice.actions
